import { Link, useNavigate, useParams } from "react-router-dom";

import { Button } from "components/Button";
import { FormStates } from "components/Forms/FormStates";
import { PageFilter } from "components/Page/PageFilter";
import { PageHeader } from "components/Page/PageHeader";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { getPlan, updatePlan } from "services/planService";
import { queryClient } from "services/queryClient";
import { PlanForm } from "../form";
import { FormFields } from "../form/viewModel";
import { PLANS_QUERY_KEY } from "../viewModel";

type QueryParams = {
  id: string;
};

export function EditPlan() {
  const { id } = useParams<QueryParams>();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { data, isLoading, isError, refetch } = useQuery(
    [PLANS_QUERY_KEY, "form", id],
    () => getPlan(id!),
    { enabled: !!id }
  );

  async function handleSubmit(fields: FormFields) {
    toast(t("plans.edit.update_loading"), { type: "info" });
    await updatePlan(id!, { 
      name: fields.name,
      description: fields.description,
      status: fields.status,
      price: fields.price
    });
    queryClient.invalidateQueries(PLANS_QUERY_KEY);
    toast(t("plans.edit.update_success"), { type: "success" });
    navigate(`/planos/${id!}`);
  }

  return (
    <div>
      <div className="flex justify-between items-center">
        <PageHeader title={t("plans.edit.title")} backPath="/planos" />
        <div className="flex items-center gap-3">
          <PageFilter hideAllFilters />
          <Link to={`/planos/${id!}`}>
            <Button>{t("actions.view")}</Button>
          </Link>
        </div>
      </div>
      <FormStates isLoading={isLoading} hasError={isError} onRetry={refetch} />
      {data && (
        <PlanForm
          enabled
          plan={data}
          onSubmit={handleSubmit}
          action={t("actions.edit")}
        />
      )}
    </div>
  );
} 